import { useSnackbar as useNotistackSnackbar } from 'notistack';
export const useSnackbar = () => {
    const { enqueueSnackbar: enqueueSnackbarNotistack } = useNotistackSnackbar();
    const enqueueSnackbar = ({ message, variant = 'default', isManualCloseButtonShown = false, internalNavigateOptions, externalLink, autoHideDuration = 4000, actionButtonText, }) => {
        const snackbarOptions = {
            variant,
            isManualCloseButtonShown,
            internalNavigateOptions,
            externalLink,
            autoHideDuration,
            actionButtonText,
            persist: isManualCloseButtonShown,
            message,
        };
        enqueueSnackbarNotistack(message, snackbarOptions);
    };
    return { enqueueSnackbar };
};
